// eslint-disable-next-line import/prefer-default-export
export const JOURNAL_PAIEMENTS = {
  titre: 'Journal des paiements',
  titreRecette: 'Journal des paiements titre de recette',
  titreFacture: 'Journal des paiements factures achat',
  racine: 'Accueil',
  table: {
    colonnes: {
      datePaiement: 'Date de paiement',
      domiciliationBancaire: 'Domiciliation bancaire',
      referencePaiement: 'Référence de paiement',
      nomTire: 'Nom du tiré',
      bailleur: 'Nom du bailleur',
      collectivite: 'Nom de la collectivité',
      fournisseur: 'Nom du fournisseur',
      compteComptable: 'Compte comptable du bailleur',
      compteComptableFournisseur: 'Compte comptable du fournisseur',
      compteComptableCollectivite: 'Compte comptable de la collectivité',
      montantPaye: 'Montant payé',
      modeReglement: 'Mode de règlement',
      codeFactureOuContrat: 'Code facture/bail',
      codeTitreRecette: 'Code titre recette',
      codeFactureAchat: 'Code facture achat',
      montantTtcARegle: 'Montant TTC à régler',
      montantLettre: 'Montant lettré',
    },
  },
  filtre: {
    titre: 'Filtre',
    sousTitre: 'Les filtres seront appliqués à la liste',
    dates: 'Période sur la date de paiement',
    domiciliationBancaire: 'Domiciliation bancaire',
    referencePaiement: 'Référence de paiement',
    nomTire: 'Nom du tiré',
    borneMontantRegle: 'Montant payé',
    bailleurs: 'Bailleurs',
    fournisseurs: 'Fournisseurs',
    collectivite: 'Collectivité(s)',
    codeFactureOuContrat: 'Code Facture ou Bail',
    codeTitreRecette: 'Code titre recette',
    codeFactureAchat: 'Code facture achat',
    actions: {
      appliquer: 'Appliquer',
      reinitialiser: 'Réinitialiser',
    },
  },
  export: {
    titre: 'Exporter le journal des paiements',
  },
};
